const workercode = () =>{
    var queryableFunctions = {
        // example #1: get the difference between two numbers:
        getDifference: function(nMinuend, nSubtrahend) {
            //reply('printStuff', nMinuend - nSubtrahend);
        },
        // example #2: wait three seconds
        wait: async function(ms = 40) {
        const self = this
        return new Promise( (resolve, reject) => {
            setTimeout(() => {
                resolve(self.postMessage({error: null,  result: "done" }))
                }, (ms >= 40) ? ms : 40);
        })
        
        },
        add: async function(a,b){
        if (typeof a !== "number" || typeof b !== "number") {
            throw new Error("both arguments must be numbers");
        }
        return Promise.resolve(this.postMessage({error: null,  result: (a+b) }))
        }
    };
    
    addEventListener("message", (event) => {
        try{
        
        let result
        if (event.data instanceof Object && event.data.hasOwnProperty('method') && event.data.hasOwnProperty('methodArgs')) {
            (queryableFunctions[event.data.method].apply(  event.ports[0], event.data.methodArgs)).then( () => {
            event.ports[0].close()
            });
        } 
    
        }catch(e) {
        event.ports[0].postMessage({error: e,  result:null});
            event.ports[0].close();
        }
    
    }, false)

}

let code = workercode.toString();
code = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));

const blob = new Blob([code], { type: "application/javascript" });
const timerworker_script = URL.createObjectURL(blob);

export default timerworker_script;
